import { CloseOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import React from 'react';
import modal from '~components/modal';
import AddAccountEditor from './editor';

@modal(
  {
    className: 'add-account-editor-modal',
  },
  true,
)
class AddAccountEditorContainer extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { t, editParams } = this.props;

    return (
      <div className="add-account-editor">
        <div className="add-account-editor__header">
          Add Partner Account
          <CloseOutlined
            className="add-account-editor__close-button"
            onClick={this.props.handleCloseModal}
          />
        </div>
        <AddAccountEditor
          t={t}
          partnerId={editParams.partnerId}
          currentOwnerId={editParams.currentOwnerId}
          partnerCountrySlug={editParams.partnerCountrySlug}
          onClose={this.props.handleCloseModal}
        />
      </div>
    );
  }
}

AddAccountEditorContainer.propTypes = {
  t: PropTypes.func.isRequired,
  editParams: PropTypes.object.isRequired,
  handleCloseModal: PropTypes.func.isRequired,
};

AddAccountEditorContainer.defaultProps = {
  t: () => {},
  editParams: {},
  handleCloseModal: () => {},
};

export default AddAccountEditorContainer;
